import React from 'react';
import { motion } from 'framer-motion';
import { PurchaseToast } from './PurchaseToast';
const resourceChips = ['Fichas visuales', 'Actividades A y B', 'Juegos', 'Evaluaciones', 'Historietas científicas'];
export function Hero() {
  return <section className="relative min-h-fit bg-transparent text-chem-navy flex flex-col items-center justify-start md:justify-center px-4 pt-4 md:pt-12 pb-2 md:pb-4 overflow-hidden font-sans" data-id="element-87" data-mp="9ipchchyjg0n">
      <div aria-hidden="true" className="chem-lattice pointer-events-none absolute inset-0" data-id="element-88" data-mp="128pft6wt8l1e" />

      <div className="relative flex flex-col items-center gap-2 mb-4 md:mb-6 text-center" data-id="element-89" data-mp="x8joxsyd72kd">
        <span className="text-chem-petrol font-black tracking-wide text-xs md:text-sm" data-id="element-90" data-mp="sddz4j1ud3r0">
          🌎 Disponible en toda LATAM · Acceso digital inmediato
        </span>
        <span className="inline-flex items-center rounded-full bg-white border border-chem-turquoise/30 px-3 py-1 text-[10px] md:text-xs font-black text-chem-petrol uppercase tracking-wide" data-id="element-91" data-mp="3d2bmnxfzddz8">
          ⚗️ Recursos visuales listos para docentes de Química de educación
          secundaria
        </span>
      </div>

      <div className="relative max-w-5xl text-center mb-4 md:mb-6" data-id="element-92" data-mp="3o6u6n92nspce">
        <h1 className="text-3xl md:text-6xl lg:text-7xl font-black leading-[1.05] tracking-tight" data-id="element-93" data-mp="399bavmrkdbvg">
          Deja de perder tus tardes{' '}
          <span className="text-chem-electric" data-id="element-94" data-mp="3ebir4ojffe3l">
            preparando Química desde cero.
          </span>
        </h1>
        <p className="text-chem-navy/80 text-sm md:text-xl font-bold leading-snug mt-4 md:mt-6 max-w-4xl mx-auto" data-id="element-95" data-mp="358rdci32w68s">
          En menos de 5 minutos tendrás: fichas, actividades, juegos y
          evaluaciones listos para imprimir antes de tu próxima clase.
        </p>
        <p className="text-chem-navy/65 text-xs md:text-base font-semibold leading-relaxed mt-3 md:mt-4 max-w-3xl mx-auto" data-id="element-96" data-mp="2vj7sx7zpw4bt">
          Química Visual reúne en un solo lugar los recursos que normalmente te
          llevan horas buscar, adaptar o crear: explicaciones visuales,
          actividades en versiones A y B, juegos, historietas científicas y
          propuestas de evaluación para secundaria.
        </p>
      </div>

      <div className="relative w-full max-w-[340px] md:max-w-[620px] mb-4 md:mb-6" data-id="element-97" data-mp="ic88ngd628yd">
        <div className="overflow-hidden rounded-3xl border border-white/70 bg-white shadow-2xl shadow-chem-navy/20 ring-1 ring-chem-petrol/10" data-id="element-98" data-mp="i9vqb23hxwks">
          <img src="https://cdn.magicpatterns.com/uploads/xbhcoYSmVqjJPc29whzi3T/quimica_visual_mockup_principal_v1.webp" alt="Biblioteca Química Visual: fichas, actividades, juegos, evaluaciones e historietas listas para imprimir" width={1254} height={1254} loading="eager"
        // @ts-ignore
        fetchpriority="high" decoding="async" className="w-full h-auto block" data-id="element-99" data-mp="1b15lh3ylzdjq" />
        </div>
      </div>

      <ul className="relative flex flex-wrap justify-center gap-1.5 md:gap-2 mb-4 md:mb-5 max-w-2xl" data-id="element-100" data-mp="3hqaian1817jz">
        {resourceChips.map(chip => <li key={chip} className="rounded-full bg-white border border-chem-petrol/15 px-2.5 py-1 text-[10px] md:text-sm font-bold text-chem-petrol" data-id="element-101" data-mp="1x786nshfdzw8">
            {chip}
          </li>)}
      </ul>

      <p className="relative text-center text-chem-navy/75 text-xs md:text-xl font-bold max-w-2xl mb-4 md:mb-6" data-id="element-102" data-mp="2b0zemwfidbpu">
        Todo lo que necesitas para explicar, practicar, evaluar y recuperar
        contenidos, listo para usar.
      </p>

      <motion.button animate={{
      boxShadow: ['0 0 15px rgba(22,163,74,0.2)', '0 0 30px rgba(22,163,74,0.5)', '0 0 15px rgba(22,163,74,0.2)'],
      scale: [1, 1.03, 1]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    })} className="relative w-full max-w-xs md:max-w-md bg-chem-green hover:bg-green-700 active:scale-95 text-white font-black text-sm md:text-xl py-5 md:py-7 px-6 md:px-10 rounded-2xl shadow-[0_10px_30px_rgba(22,163,74,0.3)] flex items-center justify-center transition-colors mb-2 text-center uppercase tracking-tight" data-id="element-103" data-mp="2kxc9vyqpbxmp">
        Acceder a los recursos ahora
      </motion.button>

      <p className="relative text-[10px] md:text-sm text-chem-petrol font-bold text-center mb-3" data-id="element-104" data-mp="3hqsdu9jci1ki">
        Pago único · Acceso digital inmediato · Material imprimible · Sin
        suscripción
      </p>

      <p className="relative text-[10px] md:text-sm text-chem-navy/60 font-medium mb-4 md:mb-6 text-center" data-id="element-105" data-mp="3rhmzbborox4w">
        🔒 Garantía de satisfacción de 7 días. Si no es adecuado para ti, puedes
        solicitar la devolución.
      </p>

      <PurchaseToast data-id="element-106" data-mp="2u0pow2aq9bq4" />
    </section>;
}